const orderDe = {
    "total": "Gesamt",
    "order_successfully_placed": "Bestellung aufgegeben",
    "empty_cart": "Ihr Warenkorb ist derzeit leer.",
    "place_order": "Bestellung aufgeben",
    "i_order": "Bestellung aufgeben",
    "order_confirmation": "Auftragsbestätigung",
    "order_confirmation_msg_raw": "Mit Ihrer Bestellung akzeptieren Sie unsere Nutzungsbedingungen und unsere Datenschutzrichtlinie, die Sie unter dem <a href=\":link\" class=\"generated-link\" target=\"_blank\">Link unten</a> finden.",
    "status_PLACED": "Platziert",
    "status_ACCEPTED": "Akzeptiert",
    "status_SERVED": "Serviert",
    "status_PAID": "Bezahlt",
    "empty_pending_orders": "Sie haben derzeit keine ausstehenden Aufträge.",
    "overview": "Bestellübersicht",
    "note": "Notiz",
    "items": "Artikel",
    "review_order": "Überblick"
};

export default orderDe;
